import { render } from "./FlushMessage.vue?vue&type=template&id=1f0b9c54&scoped=true"
import script from "./FlushMessage.vue?vue&type=script&lang=js"
export * from "./FlushMessage.vue?vue&type=script&lang=js"

import "./FlushMessage.vue?vue&type=style&index=0&id=1f0b9c54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0b9c54"]])

export default __exports__